import { render, staticRenderFns } from "./docFileTable.vue?vue&type=template&id=749bfcd4&scoped=true&lang=pug"
import script from "./docFileTable.vue?vue&type=script&lang=js"
export * from "./docFileTable.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=749bfcd4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749bfcd4",
  null
  
)

export default component.exports